import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Target, TargetStatus, QHeader, QHeaderMonths, TargetData } from '../models/target';
//import { CargaObjetivoAdministrativo } from '../models/carga-objetivo-administrativo';
import { UrlService } from '../../../@core/services/urlService/url.service';
import * as moment from 'moment';

@Injectable()
export class CargaObjetivoAdministradorService{
  private apiRoute: string;
  constructor(private urlService: UrlService, private http: HttpClient) {
  
    this.apiRoute = `${this.urlService.getBaseUrl()}CargaMasiva`;
  }
  getLogsChanel(entidad: string, codPais: string, codChanel: string): Observable<any> {
    return this.http.get(`${this.apiRoute}/${entidad}/${codPais}?codChanel=${codChanel}`);
  }

  getLogsChanelDistribuidor(entidad: string, codPais: string, codChanel: string, codDistribuidor: string): Observable<any> {
    return this.http.get(`${this.apiRoute}/${entidad}/${codPais}?codChanel=${codChanel}&codDistribuidor=${codDistribuidor}`);
  }

  cargarArchivo(entidad: string, codPais: string, codChannel: number | null, codDistribuidor: number | null, formData: FormData): Observable<any> {
    const params: any = {};

    if (codChannel !== null && codChannel !== undefined) {
      params.codChannel = codChannel;
    }

    if (codDistribuidor !== null && codDistribuidor !== undefined) {
      params.codDistribuidor = codDistribuidor;
    }

    return this.http.post<any>(`${this.apiRoute}/CargarArchivo/${entidad}/${codPais}`, formData, { params });
  }


  descargarArchivo(entidad: string, codPais: string, archivoId: string): Observable<HttpResponse<any>> {
    return this.http.get(`${this.apiRoute}/${entidad}/${codPais}/${archivoId}`, { observe: 'response', responseType: 'blob' as 'json' });
  }

  getAnioFiscal(): Observable<number> {
    return this.http.get<number>(`${this.urlService.getBaseUrl()}Objetivo/GetAnioFiscal/`);
  }

  getObjetivosAdminTemplate(codPais?: number, codChannel?: number, codDistribuidor?: number): Observable<any> {
  const params: any = {};

  if (codPais !== undefined && codPais !== null) {
    params.codPais = codPais;
  }

  if (codChannel !== undefined && codChannel !== null) {
    params.codChannel = codChannel;
  }

  if (codDistribuidor !== undefined && codDistribuidor !== null) {
    params.codDistribuidor = codDistribuidor;
  }

  return this.http.get<any>(`${this.urlService.getBaseUrl()}Objetivo/getObjetivosAdminTemplate`, { params });
}
}
